export default "__VITE_ASSET__nBNJShY3__"